var forge = require('node-forge');

export function cipher (objectJson, publicKeyInput, date) {
	var pki = forge.pki;

	var key = forge.random.getBytesSync(16);
	var iv = forge.util.hexToBytes("00000000000000000000000000000000")
	var cipher = forge.cipher.createCipher('AES-CTR', key);

	var jsonObject = JSON.stringify(objectJson);

	// console.log(jsonObject);

	cipher.start({iv: iv});
	cipher.update(forge.util.createBuffer(jsonObject));
	cipher.finish();

	var encryptedjsonObject = cipher.output;

	// console.log(encryptedjsonObject.toHex());

	// var currentDate = new Date();
	//currentDate.setSeconds(currentDate.getSeconds() + 5);
	// var dateString = currentDate.toISOString().substring(0, 19) + "Z";
	// console.log(dateString);
	// console.log(date);

	var buffer = forge.util.createBuffer(key, 'raw');
	buffer.putBytes(forge.util.encodeUtf8(date));

	var bytes = buffer.getBytes();
	var publicKey = pki.publicKeyFromPem(publicKeyInput);

	var encrypted = publicKey.encrypt(bytes, 'RSA-OAEP', {
	  md: forge.md.sha256.create(),
	  mgf1: {
	    md: forge.md.sha256.create()
	  }
	});
	// console.log(forge.util.bytesToHex(encrypted));
	var data = {
		secretKey: forge.util.encode64(encrypted),
		encryptedData: forge.util.encode64(encryptedjsonObject.getBytes())
	}

	return data;
}

export const formatDate = (dateInString) => (dispatch) => {
	var options = {
	    timeZone: "Europe/Kiev",
	    "day": "numeric",
        "month": "numeric",
        "year": "numeric",
        "hour": "2-digit",
        "minute": "2-digit",
        "second": "2-digit"
	};

	var formatter = new Intl.DateTimeFormat([], options);

	var UTCTime = dateInString;
	var localTime = formatter.format(new Date(UTCTime));
	// var currentTime = formatter.format(new Date()); console.log(currentTime, localTime);
	// var dt = new Date(Date.parse(dateInString));
 //    var localDate = dt;

 //    var gmt = localDate;
 //    var min = gmt.getTime() / 1000 / 60;
 //    var localNow = new Date().getTimezoneOffset();
 //    var localTime = min - localNow;

 //    var dateStr = new Date(localTime * 1000 * 60);
	// var locale = window.navigator.userLanguage || window.navigator.language;

	// var clientDateTimeStr = dateStr.toLocaleString(locale, {
	  	// "day": "numeric",
    //     "month": "numeric",
    //     "year": "numeric",
    //     "hour": "2-digit",
    //     "minute": "2-digit",
    //     "second": "2-digit"
	// });

	return localTime;
}